'use client'

import { cn } from '@/lib/cn'
import { getInitials } from '@/utils/getInitials'

import { Avatar, AvatarFallback, AvatarImage } from '../avatar'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../tooltip'

type UserStatus = 'ACTIVE' | 'INACTIVE'

type UserAvatarProps = {
  src?: string | null
  name?: string | null
  status?: UserStatus
  className?: string
}

export function UserAvatar({ src, name, status, className }: UserAvatarProps) {
  const isInactive =
    status === 'INACTIVE' ||
    (typeof src === 'string' && src.includes('#inactive'))

  const cleanSrc = typeof src === 'string' ? src.replace('#inactive', '') : src

  const avatar = (
    <Avatar className={cn(isInactive && 'grayscale opacity-60', className)}>
      <AvatarImage src={cleanSrc ?? undefined} />
      <AvatarFallback className={cn(isInactive && 'grayscale opacity-60')}>
        {getInitials(name ?? '')}
      </AvatarFallback>
    </Avatar>
  )

  if (!isInactive) return avatar

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{avatar}</TooltipTrigger>
        <TooltipContent>Usuário inativo</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
